import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__mv_icons_web_ccdaafc8__ from "@mv/icons/web";
import * as __WEBPACK_EXTERNAL_MODULE_ts_pattern_52f30aa9__ from "ts-pattern";
import * as __WEBPACK_EXTERNAL_MODULE__ListGroupItem_module_js_c917b939__ from "./ListGroupItem.module.js";
function ListGroupItem(props) {
    const { children, variant = 'none' } = props;
    const hasIcon = 'none' !== variant;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("li", {
        className: __WEBPACK_EXTERNAL_MODULE__ListGroupItem_module_js_c917b939__["default"].ListGroupItem,
        children: [
            hasIcon && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                role: "presentation",
                "aria-hidden": true,
                className: __WEBPACK_EXTERNAL_MODULE__ListGroupItem_module_js_c917b939__["default"].ListGroupItem__icon,
                children: (0, __WEBPACK_EXTERNAL_MODULE_ts_pattern_52f30aa9__.match)(variant).with('ok', ()=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mv_icons_web_ccdaafc8__.IconCheckCircle, {
                        size: "150"
                    })).with('nok', ()=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mv_icons_web_ccdaafc8__.IconCancel, {
                        size: "150"
                    })).with('diamond', ()=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__mv_icons_web_ccdaafc8__.Bullet, {
                        size: "150"
                    })).exhaustive()
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                children: children
            })
        ]
    });
}
export { ListGroupItem as default };

//# sourceMappingURL=ListGroupItem.js.map